<app-layout-page>
  <app-layout-header>
  </app-layout-header>

  <app-layout-content>
    <h2 trans="voice_check.media_access.title"></h2>

    <p trans="voice_check.media_access.p1"></p>

    <div class="image-section">
      <img class="large-icon" src="/assets/image/graphic/microphone-access.svg" alt="">
    </div>

    <p trans="voice_check.media_access.p2"></p>

    <div class="flex-filler"></div>

    <app-privacy-statement-link></app-privacy-statement-link>
  </app-layout-content>

  <app-layout-buttons>
    <button
      class="btn btn-primary allow pull-center"
      (click)="buttonClick()"
      trans="voice_check.media_access.button"
    ></button>

    @if (showBrowserProblemLink) {
      <app-browser-problem-link></app-browser-problem-link>
    }

    <app-skip-interaction-checkbox [interaction]="interaction" class="subdued"></app-skip-interaction-checkbox>
  </app-layout-buttons>
</app-layout-page>
